import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { StoreService } from '../store.service';
import { AccountService } from './account.service';


@Injectable({
  providedIn: 'root'
})
export class CanActivateIfNewUser implements CanActivate {

  constructor(private account: AccountService, private router: Router) {
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!this.account.getUser())
      return true;
    this.router.navigate(['/']);
    return false;
  }
}

@Injectable({
  providedIn: 'root'
})
export class CanActivateIfLoggedIn implements CanActivate {

  constructor(private account: AccountService, private router : Router) {
  }
  
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    if (this.account.getUser())
      return true;
    this.router.navigate(['/auth/login']);
    return false;
  }
}


@Injectable({
  providedIn: 'root'
})
export class CanActivateLoginRequired implements CanActivate {

  constructor(private account: AccountService, private router: Router, private store : StoreService) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.store.price == 'b2c') {
      return true;
    }

    if (this.store.loginRequired && !this.account.getUser()) {
      this.router.navigate(['/auth/login']);
      return false;
    }
    else if (this.store.loginRequired && this.account.getUser()) {
      return this.account.haveAccessB2B().pipe(tap(haveAccess => {
        if (!haveAccess) {
          this.account.requestAccessB2B().subscribe(r => {
            this.router.navigate(['/auth/b2b']);
          })
        }
      }));
    }

    return true;
  }
}
